import {
  HOOK_EVENT_TYPE_OPTIONS,
  NON_SELECTABLE_HOOK_EVENT_TYPE_OPTIONS,
} from "../constants/automation";
import type { THookEventTypeLabelKey } from "../types/automation";

const LABEL_KEY_BY_EVENT_TYPE: ReadonlyMap<string, THookEventTypeLabelKey> =
  new Map(
    [...HOOK_EVENT_TYPE_OPTIONS, ...NON_SELECTABLE_HOOK_EVENT_TYPE_OPTIONS].map(
      (eventTypeOption) => [eventTypeOption.value, eventTypeOption.labelKey],
    ),
  );

/**
 * NOTE: "chat.message.sent" -> "hooks.eventTypes.chatMessageSent" — the very key the
 * create/edit dropdown already renders, so a saved rule reads back the way it was
 * picked. Covers the event types the dropdown does not offer but the server can still
 * emit, so those rules get a readable name too. Returns "" for a code with no matching
 * option (a rule stored against an event type this client build predates), letting
 * callers fall back to the raw code instead of a missing-translation placeholder.
 */
export const getHookEventTypeLabelKey = (
  eventType: string,
): THookEventTypeLabelKey | "" => LABEL_KEY_BY_EVENT_TYPE.get(eventType) ?? "";
